import { useState } from 'react';
import {
  Box,
  Grid,
  Hidden,
  CircularProgress,
  Typography,
} from '@material-ui/core';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Head from '../../components/Head';
import Layout from '../../layout';
import { FleetsService } from '../../services';
import CardCar from './CardCar';
import CarFilter from './CarFilter';
import { useCars } from './hooks/useCars';
import ModalFiltersMobile from './ModalFiltersMobile';
import ChangePasswordModal from './ChangePasswordModal';

import useStyles from './styles';
import authService from '../../services/useCases/auth';

const formatDateTime = (value: string) =>
  new Date(value).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'America/Sao_Paulo',
  });

type Period = {
  startDate: string;
  endDate: string;
  open: boolean;
};

const Fleets = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [period, setPeriod] = useState<Period | null>(null);

  useEffect(() => {
    const [user] = authService.getUserFromToken();
    const gpId = (user as any)?.gpId;
    if (gpId && user?.email.includes(gpId) && !(user as any).passwordChanged) {
      setPasswordModal(true);
    }
  }, []);

  const { cars, setCars, setCarSelected, hasOrder, carSelected, setHasOrder } = useCars();

  useEffect(() => {
    (async () => {
      const { data } = await FleetsService.period();
      setPeriod(data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setLoading((prevState) => !prevState);
      const { data } = await FleetsService.list();
      const order = await FleetsService.listOrder();
      const cars = data;
      setCarSelected(order.data);
      setHasOrder(!!order.data.length);
      setCars(cars as any);
      setLoading((prevState) => !prevState);
    })();
  }, [setCarSelected, setCars, setHasOrder]);

  const handleModalClose = () => {};

  const handleModalCancel = () => {
    setModalOpen(false);
  };

  const handleModalBack = () => {
    setModalOpen(false);
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const handleClosePasswordModal = () => {
    setPasswordModal(false)
  }

  return (
    <Layout page="fleets" hideBackButton>
      <ChangePasswordModal open={passwordModal} onSubmit={handleClosePasswordModal}/>

      <Head>Frotas</Head>
      {period && !period.open && (
        <Box className={classes.ToolTip}>
          <p className={classes.text}>
            A inscrição vai de <strong>{formatDateTime(period.startDate)}</strong> até{' '}
            <strong>{formatDateTime(period.endDate)}</strong> (horário de Brasília).
            Você pode ver os veículos, mas ainda não é possível enviar a solicitação.
          </p>
        </Box>
      )}
      {loading ? (
        <Box marginTop={20}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {hasOrder ? (
            <Hidden mdDown>
              <Box
                display="flex"
                justifyContent="space-between"
                className={classes.ToolTip}
              >
                <p className={classes.text}>
                  Você possui um processo de solicitação de compra em andamento
                </p>
                <Link to="/frotas/veiculos-selecionados">
                  <p className={classes.textActive}>Ver informações</p>
                </Link>
              </Box>
            </Hidden>
          ) : !!carSelected.length && (
            <Hidden mdDown>
              <Box
                display="flex"
                justifyContent="space-between"
                className={classes.ToolTip}
              >
                <p className={classes.text}>
                  Você possui {carSelected.length} veículo(s), selecionado.
                </p>
                <Link to="/frotas/veiculos-selecionados">
                  <p className={classes.textActive}>Ver informações</p>
                </Link>
              </Box>
            </Hidden>
          )}
          <Hidden smUp>
            {hasOrder && (
              <Link to="/frotas/veiculos-selecionados">
                <Box
                  display="flex"
                  justifyContent="space-between"
                  className={classes.ToolTip}
                >
                  <p className={classes.text}>
                    solicitação de compra em andamento
                  </p>
                </Box>
              </Link>
            )}
          </Hidden>
          <Box
            className={classes.container}
            display="flex"
            justifyContent="space-between"
          >
            <Hidden smDown>
              <Box className={classes.containerFilters}>
                <CarFilter />
                <footer>
                  <strong className={classes.footerQA}>
                    <Link to="/frotas/perguntas-frequentes">
                      Perguntas frequentes
                    </Link>
                  </strong>
                </footer>
              </Box>
            </Hidden>
            <Box className={classes.cars}>
              <Hidden smUp>
                <Box className={classes.headerMobile}>
                  <Typography
                    className={classes.titleMobile}
                    component="strong"
                  >
                    Lista de Veículos
                  </Typography>
                  <ModalFiltersMobile
                    open={modalOpen}
                    handleClose={handleModalClose}
                    handleBack={handleModalBack}
                    handlecancel={handleModalCancel}
                  />
                  <button className={classes.buttonFilters} onClick={openModal}>
                    Filtrar
                  </button>
                </Box>
              </Hidden>
              <Grid container spacing={3}>
                {cars.map((car) => (
                  <Grid key={car.id} item xs={12} sm={3}>
                    <CardCar car={car} />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </>
      )}
    </Layout>
  );
};

export default Fleets;
